const notificationEN = {
  notification_NewMessageTemplate: 'New message received',
  notification_UserLockedTemplate: 'An user has been deactivated',
  notification_OrderPlacedTemplate: 'An order has been placed: You have received a new order from #{userName}.',
  notification_OrderUpdatedTemplate: 'An order has been updated',
  notification_OrderCancelledTemplate: 'An order has been cancelled',
  notification_InvoiceIssuedTemplate: 'A slip has been issued',
  notification_InvoicePaidTemplate: 'A slip has been paid',
  notification_InvoiceFailedTemplate: 'A slip payment has been failed',
  notification_ProposalRequestedTemplate: 'A quotation has been requested : You have received a new proposal request from #{userName}.',
  notification_ProposalUpdatedTemplate: 'A quotation has been updated: Quotation # #{quoteNumber} has been rejected by #{userName}.',
  notification_ProposalAcceptedTemplate: 'A quotation has been accepted: Quotation # #{quoteNumber} has been accepted by #{userName}.',
  notification_CartItemUpdatedTemplate: 'Cart Item has been updated',

  orderCancelledByAdminNotification: ': Order #{orderNumber} Canceled due to an issue. Please review and inform the customer.',
  orderCancelledByUserNotification: ': Order #{orderNumber} Canceled by the customer.',
  orderPaidNotification: ': Order #{orderNumber} Payment received for this order.',
  orderDeliveredNotification: ': Order #{orderNumber} Successfully delivered to the customer.',
};

export default notificationEN;
